import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=3e4f1cc2"
import script from "./PostComments.vue?vue&type=script&lang=js"
export * from "./PostComments.vue?vue&type=script&lang=js"
import style0 from "./PostComments.vue?vue&type=style&index=0&id=3e4f1cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports